module.exports = __webpack_public_path__ + "assets/images/00c371fd0383f585cada27be0c7db12f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/logos/saks-logo.jpg
// module id = 832
// module chunks = 0